import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import { DEFAULT_LOCALE, SUPPORTED_LOCALES, getStoredLocale } from '@/stores/ui.store'

import enAdmin from './en-US/admin.json'
import enAnalytics from './en-US/analytics.json'
import enAuth from './en-US/auth.json'
import enCommon from './en-US/common.json'
import enErrors from './en-US/errors.json'
import enLibrary from './en-US/library.json'
import enShare from './en-US/share.json'
import enWorkbench from './en-US/workbench.json'
import zhAdmin from './zh-CN/admin.json'
import zhAnalytics from './zh-CN/analytics.json'
import zhAuth from './zh-CN/auth.json'
import zhCommon from './zh-CN/common.json'
import zhErrors from './zh-CN/errors.json'
import zhLibrary from './zh-CN/library.json'
import zhShare from './zh-CN/share.json'
import zhWorkbench from './zh-CN/workbench.json'

const initialLocale = getStoredLocale()

void i18n.use(initReactI18next).init({
  lng: initialLocale,
  fallbackLng: DEFAULT_LOCALE,
  supportedLngs: SUPPORTED_LOCALES,
  ns: ['common', 'auth', 'workbench', 'library', 'admin', 'analytics', 'share', 'errors'],
  defaultNS: 'common',
  resources: {
    'zh-CN': {
      common: zhCommon,
      auth: zhAuth,
      workbench: zhWorkbench,
      library: zhLibrary,
      admin: zhAdmin,
      analytics: zhAnalytics,
      share: zhShare,
      errors: zhErrors,
    },
    'en-US': {
      common: enCommon,
      auth: enAuth,
      workbench: enWorkbench,
      library: enLibrary,
      admin: enAdmin,
      analytics: enAnalytics,
      share: enShare,
      errors: enErrors,
    },
  },
  interpolation: { escapeValue: false },
})

const syncDocumentLocale = (locale: string) => {
  if (typeof document === 'undefined') return
  document.documentElement.lang = locale
}

syncDocumentLocale(initialLocale)
i18n.on('languageChanged', syncDocumentLocale)

export default i18n
